/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsRestoreAccountAttributesInput } from '../models/AwsRestoreAccountAttributesInput';
import { AzureRestoreAccountAttributesInput } from '../models/AzureRestoreAccountAttributesInput';
import { GcpRestoreAccountAttributesInput } from '../models/GcpRestoreAccountAttributesInput';
import { Provider } from '../models/Provider';

export class RestoreAccountAttributesInput {
  'cloudProvider': Provider;
  'aws'?: AwsRestoreAccountAttributesInput | null;
  'azure'?: AzureRestoreAccountAttributesInput | null;
  'gcp'?: GcpRestoreAccountAttributesInput | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsRestoreAccountAttributesInput",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureRestoreAccountAttributesInput",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpRestoreAccountAttributesInput",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}



